import * as yup from 'yup';
import { FormFields } from './types';
export const validationSchema = yup.object().shape({
    [FormFields.uncollapsedBadgesCount]: yup.number().required().min(1).max(2),
});
